export const AUTH_SET_USER = "auth/set_current_user"
export const AUTH_SET_TOKEN = "auth/set_token"

export const AUTH_LOGIN_START = "auth/login/start"
export const AUTH_LOGIN_STOP = "auth/login/stop"
export const AUTH_LOGIN_SET_VALIDATIONS_ERRORS = "auth/login/set_validations_errors"
export const AUTH_LOGIN_CLEAR_VALIDATIONS_ERRORS = "auth/login/clear_validations_errors"
